import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DtisFormDialogComponent } from '@dtis/angular';
import { TranslocoModule } from '@jsverse/transloco';

export interface EditBusinessUnitDialogData {
  identifier: string;
  name: string;
  description: string;
}

export interface EditBusinessUnitDialogResult {
  name: string;
  description: string;
}

@Component({
  selector: 'dtis-admin-edit-business-unit-dialog',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, TranslocoModule, DtisFormDialogComponent],
  template: `
    <dtis-form-dialog
      [title]="'edit-business-unit'"
      [saveDisabled]="form.invalid"
      (saved)="onSave()"
      (cancelled)="dialogRef.close()"
    >
      <form [formGroup]="form" class="flex flex-col gap-4">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'business-unit-name' | transloco }}</mat-label>
          <input
            matInput
            formControlName="name"
            required
          />
          @if (form.get('name')?.hasError('required') && form.get('name')?.touched) {
            <mat-error>{{ 'name-is-required' | transloco }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'description' | transloco }}</mat-label>
          <textarea
            matInput
            formControlName="description"
            rows="3"
          ></textarea>
        </mat-form-field>
      </form>
    </dtis-form-dialog>
  `,
})
export class EditBusinessUnitDialogComponent {
  private readonly fb = inject(FormBuilder);
  readonly dialogRef = inject(MatDialogRef<EditBusinessUnitDialogComponent, EditBusinessUnitDialogResult>);
  private readonly data: EditBusinessUnitDialogData = inject(MAT_DIALOG_DATA);

  form = this.fb.group({
    name: [this.data.name, [Validators.required, Validators.minLength(2)]],
    description: [this.data.description ?? ''],
  });

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      name: this.form.value.name!,
      description: this.form.value.description ?? '',
    });
  }
}
